import React from 'react';
import PropTypes from 'prop-types';


const App = ({ children }) => (
    <div>
        {children}
    </div>
);

App.propTypes = {
    children: PropTypes.node.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/js/App.jsx